"use client"

import React from "react"

import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import useUserStore from "../store/useUserStore"



export default function PrivateRoute({ children }) {
  const navigate = useNavigate()
  const { isAuthenticated ,fetchUser} = useUserStore()

  useEffect(() => {
    const token = sessionStorage.getItem("token")
    if(token){
      fetchUser(token)
    }
    else if (!isAuthenticated) {
      navigate("/")
    }
  }, [isAuthenticated, navigate])

  if (!isAuthenticated) {
    return null
  }

  return <>{children}</>
}

